import apiService from "./apiService";
import AppConstants from "../appConstants";

class NewsReportService {
    getCurrentUserReport(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_NEWS_REPORT_CURRENT_USER, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    getReportByUser(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_NEWS_REPORT_USER, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    getReportByDate(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_NEWS_REPORT_DATE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_NEWS_REPORT_DOWNLOAD, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    // =====================================================================

    getAnalyticsSystemContent(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_ANALYTICS_SYSTEM_CONTENT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    reportAnalyticsSystemContent(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_ANALYTICS_SYSTEM_CONTENT_REPORT_DOWNLOAD, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    // =====================================================================

    getControlContentView(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CONTROL_CONTENT_VIEW, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    reportControlContentView(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_CONTROL_CONTENT_VIEW_REPORT_DOWNLOAD, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
}

export default new NewsReportService();
